import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IFiltersTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/filters-tile-definition.interface';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-filters-setup-wizard',
  template: `
    <div class="filters-setup-wizard">
      <form class="filters-setup-wizard__form" [formGroup]="setupForm">
        <div class="filters-setup-wizard__intro">
          <p>
            Use this tile to expose datasource filters. Choose the datasource the filter controls
            should target and decide whether changes should apply immediately.
          </p>
        </div>

        <app-data-source-selector
          formControlName="dataSource"
          hint="Chooses which datasource these filter controls should affect."
        ></app-data-source-selector>

        <p class="filters-setup-wizard__section-intro">
          This option controls whether filter changes apply as soon as a user changes them.
        </p>
        <mat-checkbox formControlName="autoApplyFilters">Auto apply filters</mat-checkbox>
      </form>

      <div class="filters-setup-wizard__footer">
        <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        height: 100%;
      }

      .filters-setup-wizard {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 0;
      }

      .filters-setup-wizard__form {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 16px;
        min-height: 0;
      }

      .filters-setup-wizard__intro p,
      .filters-setup-wizard__section-intro {
        margin: 0;
        color: #5c6478;
        line-height: 1.5;
      }

      .filters-setup-wizard__footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #e3e6ee;
      }
    `,
  ],
})
export class FiltersSetupWizardComponent extends TileSetupWizardComponent<IFiltersTileDefinition> {
  declare setupForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
    this.setupForm = this.fb.group({
      dataSource: [this.tileInstance?.recipe?.dataSource ?? null],
      autoApplyFilters: [this.tileInstance?.autoApplyFilters ?? false],
    });
  }

  ngOnInit() {
    this.hookForm();
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'filters',
      canView: 'true',
      autoApplyFilters: this.setupForm.controls.autoApplyFilters.value,
      recipe: {
        ...(this.tileInstance?.recipe ?? {}),
        dataSource: this.setupForm.controls.dataSource.value,
      },
    };
  }
}